import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "body-cam-footage",
  courseId: "reports-from-audio",
  order: 3,
  title: "Body-cam footage",
  subtitle: "Upload, keep video, analyze",
  summary:
    "A video is transcribed from its audio track, and the video file itself is discarded unless you keep it. With the footage add-on, the AI can also watch it.",
  learn: [
    "Upload a video and know what happens to it",
    "Decide whether to keep the original video file",
    "Turn on footage analysis if your account has the video add-on",
  ],
  minutes: 4,
  sceneId: "body-cam-footage",
  tourId: "body-cam-footage",
  releasedAt: "2026-09-24T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "You have body-cam video and need a report from it. Upload the file as you would any recording: MP4, WebM, MOV, AVI, and MKV all work. The audio is stripped out on the server and transcribed as an interaction, and the video itself is discarded to save space. Two toggles change that.",
    },
    {
      type: "steps",
      items: [
        "Click **New Case**.",
        "Click **Upload Files** and add the video. The row defaults to **Interaction**.",
        "Add the people on the recording under **Speaker Information**.",
        "Turn on **Keep original video file** if you want to play the video from the case later.",
        "If you see **Analyze the footage**, turn it on and choose \"Check the draft against the footage\" or \"Write footage observations into the draft\".",
        "Tick \"Read every minute…\" if you want a full pass instead of only the flagged windows.",
        "Click **Upload (1 file)**.",
      ],
    },
    {
      type: "paragraph",
      text: "**Keep original video file** is available only for files of 2 GB or less. Files over 2 GB are always processed as audio-only. Turning on footage analysis forces **Keep original video file** on, because the frames are read from the original.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Who sees Analyze the footage",
      text: "The toggle appears only when your department has footage analysis seats and your admin assigned one to you (the **Footage** toggle on the Officers tab). Without it, video is handled as audio only.",
    },
    {
      type: "paragraph",
      text: "Long footage uploads from your browser in the background, so stay on the page until the upload progress completes.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "For footage longer than a few minutes, dictate a short narrative alongside it. The transcript of a two-hour recording is a lot for the AI to prioritize, and your dictation tells it what mattered.",
    },
    {
      type: "paragraph",
      text: "To choose between the two footage options, read \"Verify vs enrich\". To review the results, see \"The Footage tab\".",
    },
  ],
  related: ["verify-vs-enrich", "import-from-axon-evidence", "the-footage-tab"],
};

export default lesson;
